import { useAppContext } from "../../../AppContext";
import { UserRole } from "../../enums";
import { getCurrentUserRole } from "../helpers/userHelper";
import { useApiQuery } from "./useApiQuery";
import { endpointsMetadata } from "../routes/endpointsMetadata";

export const useSupportUnreadCount = (): number => {
  const { currentUser, selectedStudio } = useAppContext();
  const isAtLeastEmployee = getCurrentUserRole(currentUser) !== UserRole.User;

  const { data } = useApiQuery<number>(
    {
      queryKey: [endpointsMetadata.supportChat.getUnreadCount, selectedStudio?.id],
      endpoint: endpointsMetadata.supportChat.getUnreadCount,
      globalIsLoading: false,
      disableErrorToast: true,
      enabled: !!currentUser && (currentUser.permissions?.length ?? 0) > 0 && isAtLeastEmployee,
    },
    { refetchInterval: 60000, staleTime: 30000 }
  );

  return data ?? 0;
};
